import ExtendedOrderFinalization from '@/features/pos/components/OrderFinalization/Extended'
import Tabs from '@/features/pos/components/Tabs'
import { usePosActiveScreen } from '@/features/pos/hooks/usePosActiveScreen'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { View } from 'react-native'

const Layout: FC = () => {
    const screenLayout = useScreenLayout()

    const posScreen = usePosActiveScreen()

    if (screenLayout === 'compact') return <Tabs />

    return (
        <View style={{ flex: 1, flexDirection: 'row' }}>
            <Tabs />
            {posScreen === 'product-catalog' ? (
                <ExtendedOrderFinalization />
            ) : (
                <View style={{ flex: 1 }}></View>
            )}
        </View>
    )
}

export default Layout
